import React from 'react';
import './App.css';
import { InsuTrack } from './components/InsuTrack';

function App() {
  return (
    <div className="App">
      <InsuTrack/>
    </div>
  );
}

export default App;
